
// src/connects/user-password-panel.jsx

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'
import { validate } from '../helpers/form-validator'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state)=> {
  return {
    user: state.user.current,
    isPasswordUpdating: state.user.isPasswordUpdating,
    isPasswordUpdateFailed: state.user.isPasswordUpdateFailed,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    validateAndSubmit: (props, event = undefined)=> {
      if (event && event.preventDefault)
        event.preventDefault();

      // check newPassword and confirmNewPassword are the same
      if (props.ui.newPassword != props.ui.confirmNewPassword) {
        props.updateUI({ confirmNewPasswordError: true })
        return false
      }
      validate(props.ui, {
          currentPassword: { rule: 'isRequired' },
          newPassword: { rule: 'isRequired' },
          confirmNewPassword: { rule: 'isRequired' },
      }, (errors, nextUI)=> {
        props.updateUI(nextUI)
        if (!errors) {
          dispatch(actions.updatePassword(props.ui.currentPassword, props.ui.newPassword, props.ui.confirmNewPassword))
        }
      })

      return false
    },

    willUpdate: (props, nextProps)=> {
      // changing isFetching true => false
      if (props.isPasswordUpdating && !nextProps.isPasswordUpdating) {
        if (!nextProps.isPasswordUpdateFailed) { // successfully updated
          dispatch(emitAlertMessage("label:パスワードを更新しました", "success"))
          nextProps.resetUI()
        }
      }
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      currentPassword: '',
      currentPasswordError: undefined,
      newPassword : '',
      newPasswordError: undefined,
      confirmNewPassword : '',
      confirmNewPasswordError: undefined
    }
  }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-password-panel.js